import {
  createReportFiltersActions,
  reportFiltersReducer,
} from './reportFilters';
import { createNamedWrapperReducer } from '../utils/createNamedWrapperReducer';

const UROFLOWMETRY_REPORTS = 'UROFLOWMETRY_REPORTS';

export const uroflowmetryReportsReducer = createNamedWrapperReducer(
  reportFiltersReducer,
  UROFLOWMETRY_REPORTS,
);
export const {
  toggleIdSelection,
  addReportId,
  removeReportId,
  removeAllReportIds,
  setFromPeriod,
  setToPeriod,
  selectTimePeriodName,
  selectDayPeriodName,
  selectDayPeriods,
  setDefaultTimePeriodName,
  setDefaultDayPeriodName,
  setDefaultDayPeriodValue,
} = createReportFiltersActions(UROFLOWMETRY_REPORTS);
